import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'
// import { GET_PHARMACY_LOST_USERS } from '../../../../queries/cartChange'

const GET_PHARMACY_LOST_USERS = gql`
  query GetPharmacyLostUsers($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-accepted*",
      size: 0,
      aggs: {
        pharmacies: {
          terms: {
            field: "items.old_pharmacy_id",
            size: 5
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number
}
const PharmaciesLoseUsers = (): JSX.Element => {
  const { filters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_PHARMACY_LOST_USERS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.eventCartChangeAggs.aggregations.pharmacies
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'pharmacies-more-lose-users'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return formatNumber(val, 0, true)
      },
      style: {
        colors: ['#304758']
      }
    },
    yaxis: {
      labels: {
        formatter: (value: number) => {
          return formatNumber(value, 0, true)
        }
      }
    }
  }
  const series = [{
    name: 'Usuários',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      TOP 5 farmácias que perderam mais usuários
    </Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.red} height={280} />
  </Paper>
}

export default PharmaciesLoseUsers
